<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Listing Optimization'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }

    @if (loaded && listingItems.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'Add a listing to generate optimization reports.'" />
        </tidy-row>
      </tidy-alert>
    }

    @if (loaded && listingItems.length > 0) {
      <tidy-row class="extra-bottom-padding">
        <tidy-text [body]="'Select a listing to generate a new optimization report.'" />
      </tidy-row>

      <tidy-row>
        <form [formGroup]="form">
          <tidy-select
            [label]="'Listing'"
            [form]="form.controls.listingId"
            formControlName="listingId"
            [items]="listingItems"
            [icon]="'assets/svg/home-outline.svg'" />
        </form>
      </tidy-row>

      <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
        <tidy-button
          [text]="'Generate New Report'"
          [action]="generateReport"
          class="primary" />
      </tidy-row>
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
